/**
 * @file: poster-studio.service.ts
 * @copyright: (c) 2019-2026 sichuan zhichetech co., ltd.
 */

import { HttpClient } from '@euler/lib/request';
import { PosterStudioTokenGrant } from '@euler/model/poster-studio';

export class PosterStudioService {
  constructor(private readonly api: HttpClient) {}

  /**
   * A one-time token that opens the poster studio as this user and store.
   * Single use, valid for a minute: fetch one each time the studio opens.
   */
  async issueToken(): Promise<PosterStudioTokenGrant> {
    return await this.api.post().url('/poster-studio/tokens').future();
  }
}
